import { Api } from 'models/services/api';
import { ReadStoresQuery } from 'models/services/graphql';

import { StoreCollectionData } from '../collection';

type DataToFetch = {
  organizationId: string;
  nextToken?: string;
};

const RequestQuery = `
  query ReadStores($organizationId: ID!, $nextToken: String) {
    ${ReadStoresQuery}
  }
`;

type ResponseData = {
  data: {
    readStores: StoreCollectionData;
  }
}

class ReadCollectionGql {

  readonly result?: StoreCollectionData;
  private readonly api: Api<ResponseData>;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToFetch): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const result = api.response.data.readStores;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, result, api });
  }

}

export { ReadCollectionGql };
